import app from 'flarum/forum/app';
import Modal from 'flarum/components/Modal';
import Button from 'flarum/components/Button';
import Stream from 'flarum/utils/Stream';

export default class AnnouncementManagementAddModal extends Modal {
  static isDismissibleViaBackdropClick = false;
  static isDismissibleViaCloseButton = true;

  oninit(vnode) {
    super.oninit(vnode);
    this.announcementData = this.attrs.announcementData;
    this.callback = this.attrs.callback;

    if(this.announcementData){
      this.text = Stream(this.announcementData.text());
      this.bilibiliLink = Stream(this.announcementData.bilibiliLink());
      this.submitType = "edit";

    }else{
      this.text = Stream("");
      this.bilibiliLink = Stream("");
      this.submitType = "add";
    }
  }

  className() {
    return 'Modal--small';
  }

  title() {
    return app.translator.trans('ziven-u2di.forum.title-add-annoucement');
  }

  content() {
    const bilibiliLink = this.bilibiliLink();

    return (
      <div className="Modal-body" style="padding-top: 0px;">
        <div className="Form" style="text-align:center">
          <div style="padding-bottom: 20px;">
            <textarea placeholder={app.translator.trans('ziven-u2di.forum.announcement-content')} style="height: 220px;" maxlength="1000" required className="FormControl" bidi={this.text} />
          </div>
          <div style="padding-bottom: 20px;">
            <input placeholder={app.translator.trans('ziven-u2di.forum.announcement-bilibili-link')} className="FormControl" bidi={this.bilibiliLink} />
          </div>
          {this.bilibiliLink() && (
            <iframe style="margin-bottom:20px" src={"//player.bilibili.com/player.html?bvid="+bilibiliLink} scrolling="no" border="0" frameborder="no" framespacing="0" allowfullscreen="true"> </iframe>
          )}
          <div>
            {Button.component({
                className: 'Button Button--primary',
                disabled: this.loading,
                type: 'submit'
              },
              app.translator.trans(this.submitType==='add'?'ziven-u2di.lib.submit':'ziven-u2di.lib.save')
            )}&nbsp;
            {Button.component({
                className: 'Button U2DiButton--gray',
                disabled: this.loading,
                onclick: () => {
                  this.hide();
                }
              },
              app.translator.trans('ziven-u2di.lib.cancel')
            )}
          </div>
        </div>
      </div>
    );
  }

  onsubmit(e) {
    e.preventDefault();

    this.loading = true;

    $(".Modal-close").hide();

    const submitData = {
      text:this.text(),
      bilibiliLink:this.bilibiliLink(),
    };

    if(this.submitType==="add"){
      app.store
        .createRecord("u2diAnnouncementList")
        .save(submitData)
        .then((result) => {
            this.hide();
            this.callback();
          }
        )
        .catch((e) => {
          this.loading = false;
        });
    }else if(this.submitType==="edit"){
      this.announcementData.save(submitData)
      .then(() => {
          this.loading = false;
          this.hide();
          m.redraw();
        },
        (response) => {
          this.loading = false;
        }
      );
    }
  }
}
